import React from "react";
import { Star } from "lucide-react";

export function StarsDisplay({ value = 0, size = 16 }) {
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="stars-display">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}
        />
      ))}
    </span>
  );
}

export function StarsInput({ value = 0, onChange, size = 32 }) {
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="stars-input">
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" onClick={() => onChange(i)} data-testid={`star-${i}`}>
          <Star
            size={size}
            className={`transition-transform hover:scale-110 ${
              i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"
            }`}
          />
        </button>
      ))}
    </span>
  );
}
